import Link from 'next/link';

interface LogoProps {
  className?: string;
  linkTo?: string;
  size?: 'sm' | 'md' | 'lg';
}

const Logo = ({ className = '', linkTo = '/landing-page', size = 'md' }: LogoProps) => {
  const sizeClasses = {
    sm: 'h-8',
    md: 'h-10',
    lg: 'h-12',
  };

  const logoContent = (
    <div className={`flex items-center gap-2 ${className}`}>
      <svg
        className={`${sizeClasses[size]} w-auto`}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="20" cy="20" r="18" fill="currentColor" className="text-primary" />
        <path
          d="M20 8C13.373 8 8 13.373 8 20C8 26.627 13.373 32 20 32C26.627 32 32 26.627 32 20C32 13.373 26.627 8 20 8ZM20 10C25.514 10 30 14.486 30 20C30 25.514 25.514 30 20 30C14.486 30 10 25.514 10 20C10 14.486 14.486 10 20 10Z"
          fill="currentColor"
          className="text-primary-foreground"
        />
        <path
          d="M16 18C16 16.895 16.895 16 18 16C19.105 16 20 16.895 20 18C20 19.105 19.105 20 18 20C16.895 20 16 19.105 16 18Z"
          fill="currentColor"
          className="text-primary-foreground"
        />
        <path
          d="M22 18C22 16.895 22.895 16 24 16C25.105 16 26 16.895 26 18C26 19.105 25.105 20 24 20C22.895 20 22 19.105 22 18Z"
          fill="currentColor"
          className="text-primary-foreground"
        />
        <path
          d="M15 24C15 24 16.5 26 20 26C23.5 26 25 24 25 24"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          className="text-primary-foreground"
        />
      </svg>
      <span className="font-heading font-semibold text-xl md:text-2xl text-text-primary">
        Livsmart<span className="text-primary">Coach</span>
      </span>
    </div>
  );

  if (linkTo) {
    return (
      <Link href={linkTo} className="inline-flex transition-smooth hover:opacity-80 focus-ring rounded-md">
        {logoContent}
      </Link>
    );
  }

  return logoContent;
};

export default Logo;